
<template>
<div>
    <div class="row" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div id="pdf" class="col-md-12">
            <div class="row mb-2">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 d-flex justify-content-center">
                        <img src="./../../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                    </div>
                    <div class="col-md-4"></div>
            </div>
            <div class="col-md-12 row">
                <div class="col-md-6">
                    <input type="date" v-model="filters.date_1" class="form-control" @input="endofday()">
                    <input type="date" v-model="filters.date_2" class="form-control" @input="endofday()">
                </div>
                <div class="col-md-6">
                    <select v-model="filters.user" class="form-control" @input="endofday()">
                        <option value="" disabled selected>All Staff</option>
                        <option v-for="user in users" :value="user.value" :key="user.value"> {{user.text}} </option>
                    </select>
                </div>
            </div>

            <div class="col-md-12">
                <div class="well">Payment Report</div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Payment Method</th>
                            <th>Payment Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="payment in payments" :key="payment.cash">
                            <td v-if="payment.cash !== null"> Cash </td>
                            <td v-if="payment.cash !== null"> {{payment.cash | formatAmount}} </td>
                        </tr>
                        <tr v-for="payment in payments" :key="payment.card">
                            <td v-if="payment.card !== null"> Card </td>
                            <td v-if="payment.card !== null"> {{payment.card | formatAmount}} </td>
                        </tr>
                        <tr v-for="payment in payments" :key="payment.bank">
                            <td v-if="payment.bank !== null"> Bank </td>
                            <td v-if="payment.bank !== null"> {{payment.bank | formatAmount}} </td>
                        </tr>
                        <tr v-for="payment in payments" :key="payment.cheque">
                            <td v-if="payment.cheque !== null"> Cheque </td>
                            <td v-if="payment.cheque !== null"> {{payment.cheque | formatAmount}} </td>
                        </tr>
                        <tr v-for="payment in payments" :key="payment.telr">
                            <td v-if="payment.telr !== null"> Telr </td>
                            <td v-if="payment.telr !== null"> {{payment.telr | formatAmount}} </td>
                        </tr>

                        <tr>
                            <td>Cash Drawer</td>
                            <td> {{drawers.Drawer | formatAmount}} AED</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-12" id="print">
                <button class="btn btn-success hidden-print" @click="print"><i class="fa fa-print"></i></button>
                <button class="btn btn-success hidden-print" @click="pdf"><i class="fa fa-file"></i></button>
        </div>
    </div>

    <div class="row" v-else>
        <notfound></notfound>
    </div>
</div>
</template>

<script>
import html2pdf from 'html2pdf.js'
export default {
    data(){
        return {
            payments:[],
            users:[],
            drawers: '',
            filters: {
                date_1: new Date().toISOString().substr(0, 10),
                date_2: new Date().toISOString().substr(0, 10),
                user_id: this.$root.id,
                name: this.$root.staffname,
                draw: 0,
                user: ''
            },
        }
    },
    created(){
        this.endofday();
    },
    methods: {
        endofday(url = './api/Report/payment') {
            this.filters.draw++
            axios
            .get(url, {params:this.filters})
            .then((result) => {
                console.log(result.data)
                this.payments = result.data.payments
                this.drawers = result.data.drawer
            }).catch((err) => {
                console.log(err)
            });
        },
        getusers() {
            axios
            .get('./api/Report/users')
            .then((result) => {
                console.log(result.data)
                this.users = result.data.users
            }).catch((err) => {
                console.log(err)
            });
        },
        print(){
            var printButton = document.getElementById("print")
            printButton.style.visibility = 'hidden'
            // var divPrint = this.$refs.print

            // window.document.write(divPrint.innerHTML)
            window.print()
            window.close()
            window.location.assign('/')
            printButton.style.visibility = 'visible'
        },
        pdf() {
            var elements = document.getElementById('pdf')

            var opt = {
            margin: 15,
            filename: 'Payment Report.pdf',
            image: {type: 'jpeg', quality: 0.98},
            html2canvas: {scale: 1},
            jsPDF: {
              unit: 'mm',
            //   format: [280, 350],
              orientation: 'landscape'
            }
          }
          html2pdf().set(opt).from(elements).save()
        }
    },
    computed: {
        taxable() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discount() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vat() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        total() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        },
        productTaxable(){
            return this.products.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0)
        },
        productDiscount() {
            return this.products.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        productVat() {
            return this.products.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0)
        },
        productTotal() {
            return this.products.reduce((total, item) => {
                return total + Number(item.price)
            }, 0)
        },

    },
    filters:{
        formatAmount: function (value) {
            return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Report/EndDay/payment.vue